import { render, staticRenderFns } from "./disease_doctor.vue?vue&type=template&id=3266e33f&scoped=true"
import script from "./disease_doctor.vue?vue&type=script&lang=js"
export * from "./disease_doctor.vue?vue&type=script&lang=js"
import style0 from "./disease_doctor.vue?vue&type=style&index=0&id=3266e33f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3266e33f",
  null
  
)

export default component.exports